import { useState, useMemo } from 'react'
import Tabs from '../../../qg-components/src/libs/Tabs'
import Modules from './Modules'
import imageSrc from './images/image.png'
import imageHoverSrc from './images/image-hover.png'
import imageColonSrc from './images/image-colon.png'

export default function AIModules() {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const [currAIModules, setCurrAIModules] = useState([{
    src: imageSrc,
    hoverSrc: imageHoverSrc,
    status: "PRODUCTIZED",
    name: "Lymph Node Metastasis, H&E, FFPE",
    descript: `Huntington's disease (HD) is a progressive brain disorder cause models differ from traditional black-box modelas they are built using interpretable AI, which enables us to go further in the research and identifd`,
  },
  {
    src: imageSrc,
    hoverSrc: imageHoverSrc,
    status: "ONGOING",
    name: "Classification, Tumor/No Tumor, H&E",
    descript: `Huntington's disease (HD) is a progressive brain disorder cause models differ from traditional black-box modelas they are built using interpretable AI, which enables us to go further in the research and identifd`,
  }])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const ais = useMemo(() => {
    return ['Breast', 'Colon', 'Lung', 'Neuroendocrine', 'Liver', 'Meningioma', 'Cervical', 'Bladder', 'General']
  }, [])
  const tabs = useMemo(() => {
    const tabs = []
    ais.forEach(ai => {
      tabs.push({
        name: ai,
      })
    })
    return tabs
  }, [ais])

  const handleChangePanel = (curr) => {
    if (curr.name === 'Colon') setCurrAIModules([
      {
        src: imageColonSrc,
        hoverSrc: imageColonSrc,
        status: "ONGOING",
        name: "Colon Classification, Tumor/No Tumor, H&E",
        descript: `Colon Huntington's disease (HD) is a progressive brain disorder cause models differ from traditional black-box modelas they are built using interpretable AI, which enables us to go further in the research and identifd`,
      }
    ])
    else setCurrAIModules([
      {
        src: imageSrc,
        hoverSrc: imageHoverSrc,
        status: "PRODUCTIZED",
        name: "Lymph Node Metastasis, H&E, FFPE",
        descript: `Huntington's disease (HD) is a progressive brain disorder cause models differ from traditional black-box modelas they are built using interpretable AI, which enables us to go further in the research and identifd`,
      },
      {
        src: imageSrc,
        hoverSrc: imageHoverSrc,
        status: "ONGOING",
        name: "Classification, Tumor/No Tumor, H&E",
        descript: `Huntington's disease (HD) is a progressive brain disorder cause models differ from traditional black-box modelas they are built using interpretable AI, which enables us to go further in the research and identifd`,
      }
    ])
  }
  return (
    <div>
      <h1 className="text-4xl pb-2">Singularity.AI Models</h1>
      <p>Singularity models has a catalog of 70+ models built using public and Owkin Data Alliance network data. These models are available to medical
        researchers and life science partners through Owkin AI Drug Development Solutions. These models differ from traditional black-box model
        s as they are built using interpretable AI, which enables us to go further in the research and identify biomarkers responsible for the predictions.
        The discovery of new multimodal biomarkers is essential to identify new biological targets, optimise clinical trial design using patients subgroups,
        and identify patients eligible for specific treatments.
      </p>
      <Tabs
        tabs={tabs}
        handleChangePanel={handleChangePanel}
      >
        <Modules modules={currAIModules}></Modules>
      </Tabs>
    </div>
  )
}
